type Runner = () => Promise<any>;

class LoadQueue {
  private concurrency: number;
  private running: number;
  private queue: Array<{ key: string; run: Runner; resolve: (v: any) => void; reject: (e: any) => void }>;

  constructor(concurrency = 1) {
    this.concurrency = Math.max(1, concurrency);
    this.running = 0;
    this.queue = [];
  }

  setConcurrency(n: number) {
    this.concurrency = Math.max(1, n);
    this.next();
  }

  enqueue(key: string, run: Runner): Promise<any> {
    return new Promise((resolve, reject) => {
      this.queue.push({ key, run, resolve, reject });
      this.next();
    });
  }

  private next() {
    if (this.running >= this.concurrency) {
      return;
    }
    const task = this.queue.shift();
    if (!task) {
      return;
    }
    this.running++;
    Promise.resolve()
      .then(() => task.run())
      .then((v) => task.resolve(v))
      .catch((e) => task.reject(e))
      .finally(() => {
        this.running--;
        this.next();
      });
  }
}

const videoLoadQueue = new LoadQueue(1);
export default videoLoadQueue;
